/**
 * Section ids for the header nav and scroll spy.
 *
 * Lives outside Header.tsx so that file exports only components — a module
 * exporting both a component and a constant defeats React Fast Refresh, which
 * then does a full reload on every edit.
 */
export const NAV_ITEMS = [
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Work' },
  { id: 'skills', label: 'Skills' },
  { id: 'resume', label: 'Resume' },
  { id: 'contact', label: 'Contact' },
] as const;

export const NAV_IDS: string[] = NAV_ITEMS.map((item) => item.id);
